import styles from '../agents.module.css';

import clsxm from '@/lib/clsxm';

import type { ChannelContent } from './types';
import { delay, SectionHeading, tone } from '../primitives';
import { useReveal } from '../useReveal';

/** What the agent takes off your plate on this channel. */
export default function ChannelJobs({
  jobs,
}: {
  jobs: ChannelContent['jobs'];
}) {
  const { ref, state } = useReveal<HTMLUListElement>(0.15);

  return (
    <section id='use-cases' className='py-20 sm:py-28'>
      <div className='mx-auto max-w-7xl px-6 lg:px-8'>
        <div className='grid gap-8 lg:grid-cols-12 lg:items-end'>
          <SectionHeading
            className='lg:col-span-7'
            title={jobs.title}
            tail={jobs.tail}
          />
          <p className={clsxm('text-lg leading-8 lg:col-span-5', tone.body)}>
            {jobs.lead}
          </p>
        </div>

        <ul
          ref={ref}
          data-reveal={state}
          className={clsxm(
            styles.reveal,
            'mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3',
          )}
        >
          {jobs.items.map(({ icon: Icon, title, detail }, index) => (
            <li
              key={title}
              className={clsxm(
                styles.rv,
                'rounded-[22px] p-6 sm:p-7',
                tone.surface,
                tone.line,
              )}
              style={delay(index * 80)}
            >
              <span className='flex h-11 w-11 items-center justify-center rounded-2xl bg-primary-50 text-primary-600 ring-1 ring-inset ring-primary-600/10 dark:bg-primary-400/10 dark:text-primary-300 dark:ring-primary-400/20'>
                <Icon className='h-5 w-5' />
              </span>
              <h3
                className={clsxm(
                  'mt-6 text-lg font-semibold tracking-[-0.01em]',
                  tone.ink,
                )}
              >
                {title}
              </h3>
              <p className={clsxm('mt-2 text-[15px] leading-7', tone.body)}>
                {detail}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
